export enum Permission {
  FoodstormOmsView = 'foodstorm_oms.view',
  FoodstormOmsModify = 'foodstorm_oms.modify',
}
